import { apiClass } from '@/common/class/api.class'
import { ENDPOINTS } from '@/common/const/endpoints.const'
import { ESIM_DESTINATIONS_TYPE } from '@/esim/const/destinations.const'

const state = {
  loading: false,
  processing: false,
  countrys: [],
  destinations: [],
  packages: [],
  destinationType: null,
  destinationName: null,
  destinationCountry: null,
  package: null
}
const mutations = {
  SET_ESIM_LOADING (state, value) {
    state.loading = value
  },
  SET_ESIM_PROCESSING (state, value) {
    state.processing = value
  },
  SET_ESIM_COUNTRYS (state, data) {
    state.countrys = data
  },
  SET_ESIM_DESTINATIONS (state, data) {
    state.destinations = data
  },
  SET_ESIM_DESTINATION_TYPE (state, data) {
    state.destinationType = data
  },
  SET_ESIM_DESTINATION_NAME (state, data) {
    state.destinationName = data
  },
  SET_ESIM_DESTINATION_COUNTRY (state, data) {
    state.destinationCountry = data
  },
  SET_ESIM_PACKAGES (state, data) {
    state.packages = data
  },
  SET_ESIM_PACKAGE (state, data) {
    state.package = data
  }
}
const actions = {
  getEsimDestinations ({ commit, state }) {
    commit('SET_ESIM_LOADING', true)
    let url = ENDPOINTS.esim.destinations
    if (state.destinationType) {
      url = `${url}/types/${state.destinationType}`
    }
    if (state.destinationName) {
      url = `${url}?name=${state.destinationName}`
    }
    return apiClass.get(url)
      .then(response => {
        commit('SET_ESIM_DESTINATIONS', response.body)
        if (!state.countrys.length) {
          commit('SET_ESIM_COUNTRYS', response.body.filter(item => item.type === ESIM_DESTINATIONS_TYPE.country))
        }
        return Promise.resolve()
      })
      .catch(error => {
        return Promise.reject(error)
      })
      .finally(() => {
        commit('SET_ESIM_LOADING', false)
      })
  },
  getEsimPackages ({ commit, state }) {
    commit('SET_ESIM_LOADING', true)
    const data = {
      name: state.destinationCountry
    }
    return apiClass.post(ENDPOINTS.esim.packages, data)
      .then(response => {
        commit('SET_ESIM_PACKAGES', response.body)
        return Promise.resolve()
      })
      .catch(error => {
        return Promise.reject(error)
      })
      .finally(() => {
        commit('SET_ESIM_LOADING', false)
      })
  },
  startEsimPayment ({ commit, state }, data) {
    commit('SET_ESIM_PROCESSING', true)
    return apiClass.post(ENDPOINTS.esim.startPayment, data)
      .finally(() => {
        commit('SET_ESIM_PROCESSING', false)
      })
  },
  resetEsim ({ commit, dispatch }) {
    commit('SET_ESIM_DESTINATION_COUNTRY', null)
    commit('SET_ESIM_DESTINATION_TYPE', null)
    commit('SET_ESIM_PACKAGES', [])
    commit('SET_ESIM_PACKAGE', null)
  }
}
const getters = {
  esimDestinationsList (state) {
    return state.destinations || []
  },
  esimDestinationsGlobalList (state) {
    if (!Array.isArray(state.destinations)) {
      return []
    }
    return state.destinations.filter(item => item.type === ESIM_DESTINATIONS_TYPE.global)
  },
  esimDestinationsRegionList (state) {
    if (!Array.isArray(state.destinations)) {
      return []
    }
    return state.destinations.filter(item => item.type === ESIM_DESTINATIONS_TYPE.region)
  },
  esimDestinationsCountryList (state) {
    if (!Array.isArray(state.countrys)) {
      return []
    }
    return state.countrys
  },
  esimPackagesList (state) {
    return state.packages || []
  },
  esimPackage (state) {
    return state.package || {}
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
